(() => {
  if (window.BellyfulProductInformation) return;
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-product-view]')];
    if (scope.matches?.('[data-product-view]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.productReady === 'true') return;
      root.dataset.productReady = 'true';
      const choices = [...root.querySelectorAll('[data-product-choice]')];
      const select = (button) => {
        const key = button.dataset.productChoice;
        root.dataset.selectedProduct = key;
        choices.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
        root.querySelectorAll('[data-product-panel]').forEach((panel) => { panel.hidden = panel.dataset.productPanel !== key; });
        root.querySelectorAll('[data-selected-product-title]').forEach((title) => { title.textContent = button.dataset.productTitle; });
        root.dispatchEvent(new CustomEvent('bellyful:product-selected', { detail: { key } }));
      };
      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-product-choice]');
        if (button && choices.includes(button)) select(button);
      });
      root.addEventListener('keydown', (event) => {
        const index = choices.indexOf(event.target.closest('[data-product-choice]'));
        if (index < 0 || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? choices.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + choices.length) % choices.length;
        choices[next].focus();
        select(choices[next]);
      });
      root.addEventListener('shopify:block:select', (event) => {
        const button = event.target.matches('[data-product-choice]') ? event.target : event.target.querySelector('[data-product-choice]');
        const panel = event.target.closest('[data-product-panel]');
        const choice = button || choices.find((item) => item.dataset.productChoice === panel?.dataset.productPanel);
        if (choice) select(choice);
      });
      if (choices.length) select(choices.find((choice) => choice.getAttribute('aria-pressed') === 'true') || choices[0]);
    });
  };
  window.BellyfulProductInformation = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
